module.exports = __webpack_public_path__ + "img/team.d7957922.jpg";